import { Box, styled } from '@mui/material';

import { TitleStyle } from './Title.types';

export const TitleContainer = styled(Box)(
  ({
    size = 6,
    color = '#3c6280',
    shadow,
    font = 'Righteous',
    align = 'center',
    cursor = 'default',
  }: TitleStyle) => ({
    textAlign: align,
    fontFamily: `'${font}', sans-serif`,
    fontSize: `${10 * size}px`,
    fontWeight: '500',
    color,
    textShadow: `${shadow ? `6px 14px 2px ${shadow}` : ''}`,
    cursor,

    '@media screen and (min-width: 1920px)': {
      fontSize: `${12 * size}px`,
    },

    '@media screen and (max-width: 1280px)': {
      fontSize: `${8 * size}px`,
      textShadow: `${shadow ? `6px ${3 * size}px 2px ${shadow}` : ''}`,
    },

    '@media screen and (max-width: 640px)': {
      fontSize: `${6 * size}px`,
      textShadow: `${shadow ? `6px ${2 * size}px 2px ${shadow}` : ''}`,
    },
  }),
);
